import { customerAPI } from '../services/api';

// PushManager.subscribe wants the VAPID key as a Uint8Array, not the base64url string
// the backend hands out — this is the standard conversion (browsers don't expose one).
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i++) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}

export const pushSupported = () => 'serviceWorker' in navigator && 'PushManager' in window;

// Existing browser-level subscription for this device, if any — independent of whether
// the backend still has a matching row (e.g. wiped by an admin, or never got there).
export async function getExistingSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

export async function enablePush() {
  if (!pushSupported()) throw new Error('Push notifications are not supported on this browser');

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('Notification permission was not granted');

  const { data } = await customerAPI.getPushPublicKey();
  if (!data?.data?.publicKey) throw new Error('Push notifications are not configured');

  const reg = await navigator.serviceWorker.ready;
  let subscription = await reg.pushManager.getSubscription();
  if (!subscription) {
    subscription = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.data.publicKey),
    });
  }

  await customerAPI.subscribePush(subscription.toJSON());
  return subscription;
}

export async function disablePush() {
  const subscription = await getExistingSubscription();
  if (!subscription) return;
  await customerAPI.unsubscribePush(subscription.endpoint).catch(() => {});
  await subscription.unsubscribe();
}
